<div class="ml-5 mr-5">
  <p class="titre1 m-4">
    {{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.TITLE' | translate }}
    <mat-icon class="material-symbols-outlined">mail</mat-icon>
  </p>

  <p class="titre2 ml-4">
    {{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.DESCRIPTION' | translate }}
  </p>

  <div class="w-full mx-auto px-4 mb-4 mt-8">
    <form (ngSubmit)="onSubmit()">
      <!-- Champ Sujet -->
      <div class="mb-4">
        <label for="sujet" class="block text-sm font-medium mb-1">
          {{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.SUJET' | translate }}
        </label>
        <input
          type="text"
          id="sujet"
          name="sujet"
          [(ngModel)]="sujet"
          (blur)="sujetTouched = true"
          maxlength="200"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="{{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.SUJET_PLACEHOLDER' | translate }}"
          />
          <div class="flex justify-between mt-1">
            @if (isSujetInvalid()) {
              <div class="text-rougeNovo text-sm">
                {{ getSujetErrorMessage() }}
              </div>
            }
            <div class="text-sm text-gray-500 ml-auto">
              {{ sujet.length }}/200
            </div>
          </div>
        </div>

        <!-- Champ Description -->
        <div class="mb-4 mt-4">
          <label for="description" class="block text-sm font-medium mb-1">
            {{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.DESCRIPTION' | translate }}
          </label>
          <textarea
            id="description"
            name="description"
            [(ngModel)]="description"
            (blur)="descriptionTouched = true"
            rows="8"
            maxlength="2000"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="{{ 'AIDE_ET_SOUTIEN.CONTACT_FORM.DESCRIPTION_PLACEHOLDER' | translate }}"
          ></textarea>
          <div class="flex justify-between mt-1">
            @if (isDescriptionInvalid()) {
              <div class="text-rougeNovo text-sm">
                {{ getDescriptionErrorMessage() }}
              </div>
            }
            <div class="text-sm text-gray-500 ml-auto">
              {{ description.length }}/2000
            </div>
          </div>
        </div>

        <!-- Boutons d'action -->
        <div class="flex justify-end gap-2 mt-6">
          <button
            type="button"
            (click)="onCancel()"
            class="btn-secondary-novo"
            >
            {{ 'COMMUN.CANCEL' | translate }}
          </button>
          <button
            type="submit"
            [disabled]="!isFormValid() || isSubmitting"
            class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed"
            >
            {{ isSubmitting ? ('COMMUN.SENDING' | translate) : ('AIDE_ET_SOUTIEN.CONTACT_FORM.SUBMIT' | translate) }}
          </button>
        </div>
      </form>
    </div>
  </div>
